// extracted by mini-css-extract-plugin
export default {"tabs":"ImportFilterTabs_tabs__NAgzo","tab":"ImportFilterTabs_tab__KWSTi","active":"ImportFilterTabs_active__hvMUw","count":"ImportFilterTabs_count__WKZuX"};